import {Event} from "../Event";

export class GroupEvents extends Event {
    public onLoad = (value: any, setField: any, setState: any, formValues: any) => {

    }
}